// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SearchResults":"ir_a bfq_a bfq_j bfq_q bfq_ro bfq_rp bfq_w"};